import { injectRemoteApp } from './injected-module-app';

function set(publicPath) {
  __webpack_public_path__ = publicPath;
}

injectRemoteApp();

export { set };
